// ** Initial State
const initialState = {
  exam: {},
};

const exams = (state = initialState, action) => {
  switch (action.type) {
    case "EMPTY_REDUCER":
      return initialState;
    case "ADD_QUESTION":
      let stateCopy = { ...state };
      let examCopy = { ...stateCopy.exam };
      stateCopy.exam = { ...examCopy, ...action.data };
      return stateCopy;
    case "ADD_EXAM":
      return { ...state };
    default:
      return { ...state };
  }
};
export default exams;
